export const setFullTime = (time: string) => {
  if (!time || time === '0') return ''
  if (time === '0:0') return ''
  const hour = time.split(':')[0].padStart(2, '0')
  const min = time.split(':')[1]?.padStart(2, '0')
  return !!time ? `${hour}:${min}` : ''
}

export function getTimeFromMins(mins: number) {
  if (mins === 0) {
    return '00:00'
  }
  if (!mins) {
    return ''
  }
  const hours = String(Math.trunc(mins / 60)).padStart(2, '0')
  const minutes = String(mins % 60).padStart(2, '0')
  return `${hours}:${minutes}`
}

export const getMin = (time: string) => {
  if (!time || !time.includes(':')) return ''
  const hour = Number(time.split(':')[0])
  const min = Number(time.split(':')[1])
  return !!hour ? hour * 60 + min : min
}
